/* eslint-disable @typescript-eslint/no-explicit-any */
import { DialogType } from "@/components/Dialogs/types";
import { pubSub } from "@/lib/PubSub";
import { isMobile } from "@/lib/isMobile";
import { routerUtils } from "@/lib/routerUtils";
import { objToUrlParams } from "@/lib/urlUtils";
import { PubSubEvents } from "@/types/PubSub";

import { dialogList, setDialogList } from "./index";

export function useDialog() {
  const showDialog = (props: {
    type: DialogType;
    data?: any;
    zIndex?: number;
  }) => {
    // 处理弹窗显示特殊事件
    const shouldContinue = handleShowDialog(props.type, props.data);

    // 如果 handleShowDialog 返回 false，则不继续执行
    if (shouldContinue === false) {
      return;
    }

    // 其他弹窗或新的 Reward 弹窗正常显示
    const timer = setTimeout(() => {
      pubSub.publish(PubSubEvents.ShowDialog, props);
      clearTimeout(timer);
    }, 210);
  };

  const closeDialog = (type: DialogType) => {
    // 处理弹窗关闭特殊事件
    const shouldContinue = handleCloseDialog(type);
    // 如果 handleCloseDialog 返回 false，则不继续执行
    if (shouldContinue === false) {
      return;
    }
    // if (isMobile()) {
    // pubSub.publish(PubSubEvents.CloseDialog, type);
    // } else {
    // 关闭前先触发开始关闭动画事件
    pubSub.publish(PubSubEvents.StartCloseAnimation, type);
    // }
  };

  /**
   * 操作弹窗显示和删除
   *
   * @example
   *   // 使用自增 zIndex
   *   operateDialog("Tips", true, { title: "提示" });
   *
   *   // 指定 zIndex
   *   operateDialog("Tips", true, { title: "提示" }, 5000);
   *
   *   // 直接使用 showDialog
   *   showDialog({
   *     type: DialogType.Tips,
   *     data: { title: "提示" },
   *     zIndex: 5000,
   *   });
   *
   * @param type - DialogType枚举
   * @param show - True:显示 False:删除
   * @param data - Dialog组件Data
   * @param zIndex - 指定 z-index，不指定则自动递增
   */
  const operateDialog = (
    type: keyof typeof DialogType,
    show: boolean = false,
    data?: any,
    zIndex?: number,
  ) => {
    if (show) {
      showDialog({
        type: DialogType[type],
        data: data,
        zIndex,
      });
    } else {
      closeDialog(DialogType[type]);
    }
  };

  // 是否存在指定的Dialog
  const hasDialog = (type: keyof typeof DialogType): boolean => {
    return dialogList().some((item) => item.type === DialogType[type]);
  };
  // 处理弹窗显示特殊事件
  const handleShowDialog = (type: DialogType, data?: any): boolean => {
    // 将对象传参转换为 URL 参数字符串
    if (type === DialogType.Profile && isMobile()) {
      // 个人资料页面
      routerUtils.push(`my-profile?${objToUrlParams(data)}`);
      return false; // 不需要继续执行 pubSub.publish
    } else if (type === DialogType.PropsList && isMobile()) {
      // 道具列表
      routerUtils.push("propsList");
      return false; // 不需要继续执行 pubSub.publish
    } else if (type === DialogType.Reward) {
      const currentDialogs = dialogList();

      // 特殊处理 Reward 弹窗：如果已存在则合并数据
      const existingRewardIndex = currentDialogs.findIndex(
        (item) => item.type === DialogType.Reward,
      );

      if (existingRewardIndex !== -1 && data?.items) {
        // 合并现有数据和新数据
        const existingDialog = currentDialogs[existingRewardIndex];
        const existingItems = existingDialog.data?.items || [];
        const newItems = data.items || [];
        const mergedItems = [...existingItems, ...newItems].sort((a, b) => {
          // 有 point 的排在前面
          const aHasPoint = a.point && a.point > 0;
          const bHasPoint = b.point && b.point > 0;

          if (aHasPoint && !bHasPoint) return -1;
          if (!aHasPoint && bHasPoint) return 1;

          // 如果都有 point 或都没有 point，保持原有顺序
          return a.walletType - b.walletType;
        });

        // 更新现有弹窗的数据，保持原有的ID和组件引用
        setDialogList((prev) => {
          const newList = [...prev];
          newList[existingRewardIndex] = {
            ...existingDialog,
            data: {
              ...existingDialog.data,
              ...data,
              items: mergedItems,
            },
          };
          return newList;
        });
        return false; // 不需要继续执行 pubSub.publish
      }
    }
    //  else if (type !== DialogType.Tips) {
    //   // // 其他弹窗如果再次调用，则关闭弹窗
    //   // const existingIndex = currentDialogs.findIndex(
    //   //   (item) => item.type === props.type,
    //   // );
    //   // if (existingIndex !== -1) {
    //   //   closeDialog(props.type);
    //   //   return;
    //   // }
    // }
    return true; // 默认需要继续执行 pubSub.publish
  };
  // 处理弹窗关闭特殊事件
  const handleCloseDialog = (type: DialogType) => {
    if (type === DialogType.Profile && isMobile()) {
      routerUtils.back();
      return false;
    }
    return true;
  };

  return {
    showDialog,
    closeDialog,
    operateDialog,
    hasDialog,
  };
}
